import React from "react";
import "./AboutHeader.css";

const AboutHeader = () => {
  return (
    <div className="about-header">
      {/* <div className="hook">
        <p>Looking for In-Depth Research?</p>
      </div> */}
    </div>
  );
};

export default AboutHeader;
